export default {
  API_PREFIX: '/workflow',
};
